import MapHelper from "@Scripts/Infrastructure/MapHelper";
import BasePage from "@Scripts/Pages/BasePage";

export default class ArchiveImageDetailPage extends BasePage {
    public static async init() {
        await super.init();

        if ((<any>window).App.bag.Image.latitude && (<any>window).App.bag.Image.longitude) {
            MapHelper.init();
        }

        this.setMap();
    }

    private static setMap() {
        let image = (<any>window).App.bag.Image;
        let markers = [];

        if (image.latitude && image.longitude) {
            var popupContent = "<img src=\"/it/media/archivio-fotografico/images/250-187-Fix/" + image.file.code + "\" /><span><div class=\"title\">" + image.title + "</div></span>";

            let marker = MapHelper.setMarker(image.latitude, image.longitude, popupContent);

            if (marker) {
                markers.push(marker);
            }
        }

        MapHelper.setBounds(markers);
    }
}